module.exports = __webpack_public_path__ + "img/ic_bed_heat3.82f349f0.png";